import React, { useState } from 'react';
import styles from './Personals.module.css';
import PickTemplates from '../components/PickTemplates/PickTemplates';
import PersonalUsers from './PersonalUsers/PersonalUsers';
import useApi from '../../../hooks/useApi.hook';
import Spinner from '../../Spinner/Spinner';
import {apiErrorMessage} from '../../../helpers/apiError';
import {notifyDownloadQueued} from '../../../helpers/downloadsEvents';
import {getAllDocumentsUrl} from '../../../helpers/constants';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';

export function Personals() {
	const api = useApi();
	const [selectedTemplate, setSelectedTemplate] = useState('');
	const [placeholders, setPlaceholders] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [error, setError] = useState(undefined);
	const [loading, setLoading] = useState(false);

	const handleGenerate = async () => {

		const plh = placeholders
			.filter((p) => p.key?.trim() && p.value?.trim())
			.map((p) => ({ key: p.key, value: p.value }));

		if (!selectedTemplate || selectedUsers.length === 0) return;
		setError(undefined);
		setLoading(true);
		try {
			const response = await api.post(`${getAllDocumentsUrl}/personal_generate`, {
				template: selectedTemplate,
				users_uuid_list: selectedUsers,
				placeholders: plh
			});

			notifyDownloadQueued(response.data);
		} catch (e) {
			setError(apiErrorMessage(e));
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={styles.container}>
			<ErrorMessage
				error={error}
				onClose={() => setError(undefined)}
			/>
			<div className={styles.topRow}>
				<PickTemplates
					groupName="personal"
					selectedTemplate={selectedTemplate}
					setSelectedTemplate={setSelectedTemplate}
					placeholders={placeholders}
					setPlaceholders={setPlaceholders}
				/>
				<PersonalUsers
					selectedUsers={selectedUsers}
					setSelectedUsers={setSelectedUsers}
					onGenerate={handleGenerate}
					loading={loading}
					selectedTemplate={selectedTemplate}
				/>
			</div>
			{loading && (
				<div className={styles.spinnerOverlay}>
					<Spinner showSeconds={true} />
				</div>
			)}
		</div>
	);
}